<template>
  <div :class="padding ? 'padding ':''">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SCardSection",
  props: {
    padding: { type: Boolean },
    title: { type: String, default: "#" },
    icon: { type: String, default: "" },
  },
  computed:{
    cardStyles(){
      let cpadding, cborder;
     if(this.padding){
       cpadding = "24px";
     }
     if(this.border){
       cborder = "solid 1px var(--very-light-pink)";
     }  
     return{
       padding: cpadding,
       border: cborder
     }
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 24px;
}
</style>
